export default __webpack_public_path__ + "static/media/20.fc80df5a.svg";